<twc-drawer [clearHeader]="true" caption="{{ 'NOTIFICATION_PANEL.TITLE' | translate }}" position="right">
    <twc-drawer-content>
        <cw-notification-panel></cw-notification-panel>
    </twc-drawer-content>
</twc-drawer>